import * as React from 'react'

import { XIcon } from 'lucide-react'

import { Button } from '~/client/src/shared/components/shadcn-ui/button'
import { SidePanel } from '~/client/src/shared/components/SidePanel/SidePanel'
import Spinner from '~/client/src/shared/components/Spinner/Spinner'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import { useResource } from '../context'

/**
 * The edit panel while the selected record is not in the list. A resource just created is
 * open by its new id a beat before the subscription delivers its record, so it waits on a
 * spinner, closable in case that never comes; any other missing record shows no panel.
 */
export const PendingRecordPanel: React.FC = () => {
  const {
    state: { selectedRecordId, pendingCreatedRecordId },
    actions: { closeEditPanel },
  } = useResource()

  if (selectedRecordId !== pendingCreatedRecordId) return null

  return (
    <SidePanel>
      <div className="tw:relative tw:flex tw:items-center tw:justify-center tw:size-full tw:bg-background">
        <Button
          variant="ghost"
          size="icon-sm"
          className="tw:absolute tw:top-3 tw:right-3"
          aria-label={Localization.translator.close}
          onClick={closeEditPanel}
        >
          <XIcon />
        </Button>
        <Spinner size="md" />
      </div>
    </SidePanel>
  )
}
